class TouchmoveDirective {
    constructor() {
        this.restrict = 'A';
    }

    link(scope, element, attrs) {
        element.on('touchmove', function(event) {
            scope.$event = event;
            scope.$apply(function() {
                scope.$eval(attrs.touchmove);
            });
        });
        element.on('mousemove', function(event) {
            scope.$event = event;
            scope.$apply(function() {
                scope.$eval(attrs.touchmove);
            });
        });
    }

    static directiveFactory() {
        'ngInject';
        return new TouchmoveDirective();
    }
}

export default TouchmoveDirective;
